// Global Add to Cart and Wishlist functionality for product cards
document.addEventListener('DOMContentLoaded', function () {
  // Add to Cart functionality
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('add-to-cart-btn') || e.target.closest('.add-to-cart-btn')) {
      e.preventDefault();
      const button = e.target.classList.contains('add-to-cart-btn')
        ? e.target
        : e.target.closest('.add-to-cart-btn');

      if (button.disabled) return;

      const variantId = button.dataset.productId;
      const quantity = button.dataset.quantity || 1;

      // Disable button and show loading
      button.disabled = true;
      const originalText = button.innerHTML;
      button.innerHTML = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `id=${variantId}&quantity=${quantity}`,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status && data.status === 422) {
            throw new Error(data.description || 'Product unavailable');
          }
          showNotification('✓ Added to cart!', 'success');
          updateCartCount();
        })
        .catch((error) => {
          console.error('Error:', error);
          showNotification(error.message || 'Failed to add to cart', 'error');
        })
        .finally(() => {
          button.disabled = false;
          button.innerHTML = originalText;
        });
    }
  });

  // Override the global removeFromWishlist function to handle card removal
  window.removeFromWishlist = function (productId) {
    // Remove from localStorage immediately
    let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    wishlist = wishlist.filter((item) => item.id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    // Find the remove button and get its parent card
    const removeButton = document.querySelector(
      `button[onclick*="removeFromWishlist('${productId}')"]`
    );
    let productCard = null;

    if (removeButton) {
      // Find the card container (try multiple parent levels)
      productCard =
        removeButton.closest('.card') ||
        removeButton.closest('.grid__item') ||
        removeButton.closest('.col-12') ||
        removeButton.closest('.col-md-6') ||
        removeButton.closest('.col-lg-3') ||
        removeButton.closest('[data-product-id]');
    }

    // Fallback: try to find by data-product-id
    if (!productCard) {
      productCard = document.querySelector(`[data-product-id="${productId}"]`);
    }

    if (productCard) {
      productCard.style.transition = 'all 0.3s ease';
      productCard.style.transform = 'scale(0.8)';
      productCard.style.opacity = '0';

      setTimeout(() => {
        productCard.remove();

        // Check if wishlist is empty
        const remainingItems = document.querySelectorAll(
          '#wishlist-items .card, #wishlist-items [data-product-id]'
        );
        if (remainingItems.length === 0) {
          const emptyState = document.getElementById('wishlist-empty');
          const itemsContainer = document.getElementById('wishlist-items');
          if (emptyState && itemsContainer) {
            emptyState.style.display = 'block';
            itemsContainer.style.display = 'none';
          }
        }
      }, 300);
    }

    // Update counts and states immediately
    updateWishlistCount();
    updateHeartButtonStates();
    showNotification('Product removed from wishlist', 'success');
  };

  // Wishlist functionality
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('wishlist-btn') || e.target.closest('.wishlist-btn')) {
      e.preventDefault();
      const button = e.target.classList.contains('wishlist-btn')
        ? e.target
        : e.target.closest('.wishlist-btn');

      const productData = {
        id: button.dataset.productId,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage,
        price: button.dataset.productPrice,
        dateAdded: new Date().toISOString(),
      };

      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      const existingIndex = wishlist.findIndex((item) => item.id === productData.id);

      if (existingIndex !== -1) {
        // Remove from wishlist
        wishlist.splice(existingIndex, 1);
        button.classList.remove('active');
        showNotification('Removed from wishlist', 'success');
      } else {
        // Add to wishlist
        wishlist.push(productData);
        button.classList.add('active');
        showNotification('♥ Added to wishlist!', 'success');
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      updateWishlistCount();

      // Update heart button states globally
      updateHeartButtonStates();
    }
  });

  // Initialize wishlist button states
  function initializeWishlistButtons() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const wishlistIds = wishlist.map((item) => item.id);

    document.querySelectorAll('.wishlist-btn').forEach((button) => {
      const productId = button.dataset.productId;
      if (wishlistIds.includes(productId)) {
        button.classList.add('active');
      }
    });
  }

  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const cartCounters = document.querySelectorAll('.cart-count, [data-cart-count]');
        cartCounters.forEach((counter) => {
          counter.textContent = cart.item_count;
        });

        window.dispatchEvent(
          new CustomEvent('cartUpdated', { detail: { count: cart.item_count } })
        );
      })
      .catch((error) => console.error('Error updating cart count:', error));
  }

  // Update wishlist count
  function updateWishlistCount() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const count = wishlist.length;

    const wishlistCounters = document.querySelectorAll('.wishlist-count, [data-wishlist-count]');
    wishlistCounters.forEach((counter) => {
      counter.textContent = count;
      counter.style.display = count > 0 ? 'inline' : 'none';
    });

    window.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { count } }));
  }

  // Show notification
  function showNotification(message, type) {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 18px;
      border-radius: 6px;
      color: white;
      font-weight: 500;
      z-index: 9999;
      opacity: 0;
      transform: translateX(100%);
      transition: all 0.3s ease;
      background-color: ${type === 'success' ? '#28a745' : '#dc3545'};
      font-family: 'Crete Round', serif;
      font-size: 16px;
      min-width: 250px;
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.opacity = '1';
      notification.style.transform = 'translateX(0)';
    }, 100);

    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // Initialize on page load
  initializeWishlistButtons();
  updateWishlistCount();

  // Update heart button states across the site
  function updateHeartButtonStates() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const wishlistIds = wishlist.map((item) => item.id);

    // Update all heart buttons on the page
    document.querySelectorAll('[data-product-id]').forEach((heartBtn) => {
      const productId = heartBtn.getAttribute('data-product-id');
      const icon = heartBtn.querySelector('i');

      if (wishlistIds.includes(productId)) {
        heartBtn.classList.add('liked');
        if (icon) {
          icon.classList.remove('bi-heart');
          icon.classList.add('bi-heart-fill');
        }
        heartBtn.style.color = '#e74c3c';
      } else {
        heartBtn.classList.remove('liked');
        if (icon) {
          icon.classList.remove('bi-heart-fill');
          icon.classList.add('bi-heart');
        }
        heartBtn.style.color = '#1E2938';
      }
    });

    // Also update wishlist buttons
    document.querySelectorAll('.wishlist-btn').forEach((btn) => {
      const productId = btn.dataset.productId;
      if (wishlistIds.includes(productId)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  // Make functions globally available
  window.updateWishlistCount = updateWishlistCount;
  window.updateCartCount = updateCartCount;
  window.updateHeartButtonStates = updateHeartButtonStates;

  // Ensure removeFromWishlist is available globally
  if (!window.removeFromWishlist) {
    window.removeFromWishlist = function (productId) {
      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      wishlist = wishlist.filter((item) => item.id !== productId);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));

      const productCard = document.querySelector(`[data-product-id="${productId}"]`);
      if (productCard) {
        productCard.style.transition = 'all 0.3s ease';
        productCard.style.transform = 'scale(0.8)';
        productCard.style.opacity = '0';
        setTimeout(() => productCard.remove(), 300);
      }

      updateWishlistCount();
      updateHeartButtonStates();
    };
  }
});
